import { EyeIcon } from "@heroicons/react/24/solid";
import React from "react";

const ShowButton = ({ buttonText, onClick, className, disabled }) => {
  return (
    <button
      disabled={disabled}
      onClick={onClick}
      className={
        (disabled
          ? "cursor-not-allowed border text-white bg-quinary border-quinary"
          : "text-white bg-quinary border-quinary") +
        `hover:scale-90  bg-quinary shadow-md h-5  lg:h-6 lg:px-1 w-16 lg:w-20 border-quinary text-white hover:border-hquinary hover:bg-hquinary hover:text-white flex flex-row items-center justify-around text-xs3 border rounded-full transition duration-500 ease select-none focus:outline-none focus:shadow-outline undefined ${className}`
      }
    >
      <EyeIcon className="h-4 w-4 -mr-3" />
      <div>{buttonText}</div>
    </button>
  );
};
export default ShowButton;
